/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useState } from "react";
import { selectDialogState } from "redux/slices";
import Button from "components/Buttons/ThemeButton";
import CloseIconButton from "../lib/CloseIconButton";
import { useAppDispatch, useAppSelector } from "hooks";
import { onSuppress } from "redux/slices/web-store/thunks";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import {
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel,
	FormGroup,
	Grid,
	Typography
} from "@mui/material";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { CustomDialog } from "./styles";
import { IPlaygamiAnalyticProps } from "interfaces/analytics/playgami";

const buttonStyles = {
	paddingTop: ".75rem",
	paddingBottom: ".75rem",
	marginBottom: 1,
	width: "100%"
};

const DialogShopPurchaseSuccess = ({
	show,
	onCloseClick
}: {
	show: boolean;
	// eslint-disable-next-line
	onCloseClick: (event?: any, reason?: string) => void;
}) => {
	const dispatch = useAppDispatch();
	const [suppress, setSuppress] = useState<boolean>(false);
	const { props } = useAppSelector(selectDialogState);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const scale = useCalculateScale(370 + 40, 346 + 40);

	const reportAnalytics = ({ event_name }: IPlaygamiAnalyticProps) => {
		const event_type = "purchase_success_dialog";
		reportPlaygamiEvent("tp.web_frontend", {
			event_name,
			event_type,
			action: event_name,
			source: event_type
		});
	};

	const [
		isSuppressOrderConfirmationChecked,
		setIsSuppressOrderConfirmationChecked
	] = useState(false);

	const { postUserMetadata } = props || {
		// eslint-disable-next-line
		postUserMetadata: (arr: any) => undefined
	};

	const onClick = () => {
		reportAnalytics({
			event_name: "dialog_click"
		});
		onSuppressOrder();
		onCloseClick?.();
	};

	const onClose = () => {
		reportAnalytics({
			event_name: "dialog_x_closed"
		});
		onCloseClick?.();
	};

	const labelText = "Don’t show me this again";
	const label = {
		inputProps: {
			"aria-label": labelText,
			onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
				setIsSuppressOrderConfirmationChecked(event.target.checked);
				const userMetaData = {
					key: "suppressOrderConfirmation",
					value: event.target.checked ? "true" : "false"
				};
				postUserMetadata && postUserMetadata(userMetaData);
			}
		}
	};

	const onSuppressOrder = useCallback(() => {
		if (suppress) {
			dispatch(onSuppress({ key: "suppressOrderConfirmation", value: "true" }));
			localStorage.setItem(
				"store.solitairetripeaks.com:suppressConfirmation",
				"true"
			);
		}
	}, [suppress]);

	useEffect(() => {
		if (show) {
			reportAnalytics({ event_name: "dialog_shown" });
		}
	}, [show]);

	return (
		<CustomDialog scale={scale} open={show} onClose={onClose}>
			<DialogTitle>
				<CloseIconButton onClose={onClose} />
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: 0 }}>
				<DialogContentText sx={{ padding: ".14rem 1rem" }}>
					<Typography
						variant="h4"
						component="strong"
						sx={{
							fontWeight: "bold",
							margin: "1rem 0 .75rem",
							display: "block",
							textAlign: "center",
							fontSize: {
								xs: "26.4px"
							},
							lineHeight: 1,
							color: "#333333"
						}}
					>
						Your purchase is now in your in-game inbox.
					</Typography>
					<Typography
						sx={{
							marginTop: "18px",
							fontSize: { sm: "16px" }
						}}
					>
						Thank you for using our Tiki Solitaire TriPeaks Web Shop. Your
						purchase is now waiting to be collected in your in-game inbox.
					</Typography>
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center", flexDirection: "column" }}>
				<Grid
					container
					sx={{
						padding: "0 2rem",
						flexDirection: "row-reverse",
						justifyContent: "center"
					}}
				>
					<Grid item xs={12}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<Button
									onClick={onClick}
									sx={{
										...buttonStyles
									}}
								>
									Okay
								</Button>
							</Grid>
							{/* {isMobile && (
								<Grid item xs={12} sm={6}>
									<BackToGameButton
										source={"shop_purchase_success_dialog"}
										themeColor="secondary"
										sx={{
											...buttonStyles,
											backgroundColor: "#4088B7",
											"&:hover": {
												backgroundColor: "#25506d"
											}
										}}
									/>
								</Grid>
							)} */}
						</Grid>
					</Grid>
					<Grid item xs={12} sm={12}>
						<Typography sx={{ margin: "0px 0", fontSize: "12px" }}>
							<FormGroup>
								<FormControlLabel
									control={
										<Checkbox
											onClick={() => {
												setSuppress(!suppress);
											}}
											checked={isSuppressOrderConfirmationChecked}
											color="success"
											{...label}
										/>
									}
									label={labelText}
									disableTypography={true}
								/>
							</FormGroup>
						</Typography>
					</Grid>
				</Grid>
			</DialogActions>
		</CustomDialog>
	);
};

export { DialogShopPurchaseSuccess };
